import {firebaseApp$, firebaseConfig, lazyLoadFirebase} from './config';

export const FirebaseService = {
  app: firebaseApp$,
  firebaseConfig,
  lazyLoadFirebase,
};
